import React from 'react';
import _ from 'lodash';
import {Column} from "../styled/flex";
import connectFirebase from "../lib/firebase/connectFirebase";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import './ChatList.scss';

export class ChatList extends React.PureComponent {
  render() {
    const {chatrooms, className = ''} = this.props;

    return <Column className={"chat-list " + className}
      style={{
        width: 200,
        overflowX: 'hidden',
        overflowY: 'auto',
        flexShrink: 0
      }}
    >
      {_.map(chatrooms, c => <Link
        key={c.id}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
        to={`/chat/${c.userId}`}>
        {c.name}({c.userId})
      </Link>)}
    </Column>;
  }
}

const getListeners = ({firebase}) => {
  return {
    chatrooms: () => firebase.firestore().collection('chatrooms').orderBy('lastMessageTime', 'desc').limit(100)
  };
};



export const ConnectedChatList = connectFirebase(getListeners)(ChatList);
